import { CaretDownOutlined } from '@ant-design/icons';
import Button from '@ui-library/button';
import { SubHeader } from '@components/sources/source/warehouseSource/configureData/style';
import useStores from '@stores/useStores';
import { Dropdown, Menu } from 'antd';
import { sortBy } from 'lodash';
import * as React from 'react';
import { findBestMatch } from 'string-similarity';
import { FixMe } from '@utils/types';
import { IColumn } from '@components/sources/source/warehouseSource/configureData/sourceSpecificConfig';
import { IField, IMappingConfig, useConnectionState } from '../../../visualDataMappingProvider';
import classes from '../mapping-commons.module.scss';

interface MoreActionsProps {
  showResetMappingsModal: (show: boolean) => void;
}

const MoreActionsDropdown = ({ showResetMappingsModal }: MoreActionsProps) => {
  const { fields, uniqueIdentifierConfig, mappingConfig, columns, setMappingConfig, fieldMap } =
    useConnectionState();
  const { messagesStore } = useStores();
  const sortMappingConfig = () => {
    const updatedConfig = sortBy(mappingConfig, [
      (a: IMappingConfig) => fieldMap[a.mapped || '']?.label,
    ]);
    setMappingConfig(updatedConfig);
    messagesStore.showSuccessMessage('Mappings are sorted by fields name');
  };
  const onAction = (action: 'remove' | 'match' | 'addNextTen' | 'sortAlphabetically') => {
    let newMappingConfig: IMappingConfig[] = [];
    let count = 0;

    switch (action) {
      case 'remove':
        showResetMappingsModal(true);
        break;
      case 'match':
        newMappingConfig = fields.reduce((accum: IMappingConfig[], field: IField) => {
          if (
            field.name !== uniqueIdentifierConfig?.mapped &&
            !mappingConfig.some((curr) => curr.mapped === field.name)
          ) {
            let newMap: IMappingConfig;
            const result = findBestMatch(
              field.label,
              columns.map((col: IColumn) => col.name),
            );
            if (result && result?.bestMatch?.rating > 0.5) {
              newMap = {
                mapped: field.name,
                original: result?.bestMatch.target,
              };
              accum.push(newMap);
            }
          }
          return accum;
        }, []);
        if (newMappingConfig.length === 0) {
          messagesStore.showErrorMessage('All matching fields are already added');
        } else {
          messagesStore.showSuccessMessage('Matching fields are added');
        }

        newMappingConfig = [...mappingConfig, ...newMappingConfig];
        setMappingConfig(newMappingConfig);

        break;
      case 'addNextTen':
        newMappingConfig = mappingConfig;
        fields.every((field) => {
          if (count >= 10) {
            return false;
          }
          if (
            field.name !== uniqueIdentifierConfig.mapped &&
            !mappingConfig.some((curr) => curr.mapped === field.name)
          ) {
            newMappingConfig.push({ mapped: field.name });
            count += 1;
          }
          return true;
        });
        if (count) {
          messagesStore.showSuccessMessage(`Next ${count.toLocaleString()} fields are added`);
        } else {
          messagesStore.showErrorMessage('All fields are already added');
        }
        setMappingConfig(newMappingConfig);
        break;
      case 'sortAlphabetically':
        sortMappingConfig();
        break;
      default:
        break;
    }
  };
  const menu = (
    <Menu onClick={(r: FixMe) => onAction && onAction(r.key)}>
      <Menu.Item key="sortAlphabetically" className={classes.dropdownButton}>
        <span className={classes.dropdownButton_icon}>Aa</span>
        Sort alphabetically
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="match" className={classes.dropdownButton}>
        <span className={classes.dropdownButton_icon}>+</span>
        Bulk add matchable fields
      </Menu.Item>
      <Menu.Item key="addNextTen" className={classes.dropdownButton}>
        <span className={classes.dropdownButton_icon}>+</span>
        Add next 10 fields
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="remove">
        <span className={`${classes.dropdownButton} ${classes.warning_color}`}>
          <span className={classes.dropdownButton_icon}>-</span>
          Reset Fields
        </span>
      </Menu.Item>
    </Menu>
  );
  return (
    <Dropdown placement="bottomRight" overlay={menu}>
      <Button secondary>
        <SubHeader>
          More
          <CaretDownOutlined />
        </SubHeader>
      </Button>
    </Dropdown>
  );
};
export default MoreActionsDropdown;
